import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-candidate-attachment',
  templateUrl: './candidate-attachment.component.html',
  styleUrls: ['./candidate-attachment.component.scss'],
  standalone: false,
})
export class CandidateAttachmentComponent implements OnInit {
  attachments: [];
  documentPresent = {};
  constructor(
    public dialogRef: MatDialogRef<CandidateAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    for (const [rawKey, value] of Object.entries(this.data || {})) {
      const key = rawKey[0].toUpperCase() + rawKey.slice(1);
      this.documentPresent[key.replace(/([A-Z])/g, ' $1').trim()] = value;
    }
  }

  OnClose() {
    this.dialogRef.close();
  }
}
